{
  "en": {
    "materials": {
      "collectionEmpty": {
        "communityTab": "Have a look at the material by the fobizz community.",
        "partnerTab": "Have a look at the material by fobizz & partners",
        "title": "Nothing found?",
        "viewCommunityMaterial": "View material by the fobizz community",
        "viewPartnerMaterial": "View material by fobizz & partners"
      },
      "collectionTeaser": {
        "linkName": "Learn more",
        "title": "Everything worth knowing about collections"
      },
      "filters": {
        "language": "Language",
        "order": {
          "label": "Order by",
          "newest": "newest",
          "relevance": "relevance"
        }
      },
      "galleryTeaser": {
        "linkName": "Learn more",
        "title": "All you need to know about the gallery"
      },
      "headings": {
        "toTeach": "These resources are provided by our partner, <a href=\"https://app.fobizz.com/partners/34-to-teach\" target=\"_blank\">to teach</a>. Create a free account to use all existing template and create up to 10 additional materials for free each month."
      },
      "howTo": {
        "header": {
          "heading": "The fobizz gallery - what to expect",
          "list_html": "<li><i class='bi bi-check-lg'></i>Receive inspiration from other teachers for your lessons</li>\n          <li><i class='bi bi-check-lg'></i>Use material that has been tried and tested by others</li>\n          <li><i class='bi bi-check-lg'></i>Easily customize templates and examples with the fobizz tools</li>\n          <li><i class='bi bi-check-lg'></i>Save time by sharing lesson ideas and material with others</li>\n          <li><i class='bi bi-check-lg'></i>Discover collections of ready-made lesson plans on specific topics</li>"
        },
        "recommendations": {
          "heading": "Discover current collections"
        },
        "terms": {
          "collections": {
            "description_html": "In the gallery you will find collections of teaching material <strong>on specific topics</strong>. You can pick out individual elements and adapt them or use <strong>complete lesson plans</strong> with all the material you need in the lesson.",
            "heading": "Collections?"
          },
          "copyright": {
            "description_html": "In the spirit of <strong>OER</strong> (Open Educational Resources), all content published by teachers in the gallery is under the <a href=\"https://creativecommons.org/licenses/by/3.0/de/\" target=\"_blank\">Creative Commons CC-BY license</a>. That means you can use, edit and distribute them free of charge.",
            "heading": "Copyright?"
          },
          "description": "You will encounter the following terms in the gallery. Find out what they mean.",
          "heading": "So what about...",
          "link": "Discover teaching material now",
          "remix": {
            "description_html": "With just one click of the <strong>Remix button</strong>, you can copy any material in the gallery into your <strong>own clipboard</strong> - like a digital master copy. Use the material directly in the lesson or flexibly adapt individual elements before use.",
            "heading": "Remix?"
          }
        },
        "tile": {
          "heading": "Find content that is just right for you",
          "help": {
            "author": "Author of the material",
            "bookmark": "Heart for your watch list",
            "kind": "Type of content"
          },
          "link": "Back to the gallery",
          "list_html": "<li><i class='bi bi-check-lg'></i>Search for <strong>topics and keywords</strong> and further refine the results: by recommended school type, age group or subject.</li>\n          <li><i class='bi bi-check-lg'></i>Save interesting content for later by clicking on the heart to add it to your <strong>personal watch list</strong>.</li>\n          <li><i class='bi bi-check-lg'></i>See the <strong>popularity of a material</strong> at a glance. The number of remixes tells you exactly how often it has already been reused by others.</li>",
          "material_title": "No homework at all? AI - chances and limits"
        },
        "title": "How to"
      },
      "labels": {
        "approvedUserIds": "Partners",
        "filterCollection": "Collection",
        "galleryCommunityPlaceholder": "Search fobizz community material",
        "galleryFallbackPlaceholder": "Search content",
        "galleryPlaceholder": "Seach fobizz & partner material",
        "galleryToTeachPlaceholder": "Search to teach content",
        "models": "Materials"
      },
      "searchPlaceholder": "Search fobizz Material...",
      "toTeachImport": {
        "importing": "Importing worksheet...",
        "importingDescription": "Your to teach worksheet is being converted into a fobizz worksheet. This may take a moment.",
        "importFailed": "Import failed. Please try again.",
        "importNotFound": "The worksheet was not found.",
        "importQueued": "Your worksheet is being imported in the background.",
        "importReady": "Your to teach worksheet has been successfully imported!"
      },
      "subNav": {
        "community": "fobizz Community",
        "fobizz": "fobizz & Partners",
        "toTeach": "to teach Content"
      }
    }
  }
}
